import { Component, OnInit, Input } from '@angular/core';
import { GtmService } from '../../services/gtm.service';
import { TooltipMobileComponent } from './tooltip-mobile/tooltip-mobile.component';
import { GTM_PUSH_CATEGORY_INTERRACTIONS_PAGES, GTM_PUSH_CATEGORY } from '../../modeles/variables';
import { OpenModalService } from '../../services/open-modal/open-modal.service';

@Component({
  selector: 'app-tooltip',
  templateUrl: './tooltip.component.html',
  styleUrls: ['./tooltip.component.scss'],
  standalone: false
})
export class TooltipComponent implements OnInit {
  @Input()
  id?: string;

  @Input()
  titre: string;

  @Input()
  texte: string;

  @Input()
  altText = '';

  @Input()
  ariaLabel: string;

  @Input() showQuestionMark = true;
  @Input() isInsideText = false;

  @Input() placement: 'top' | 'bottom' = 'top';
  @Input() width = '19rem';

  constructor(private readonly _gtm: GtmService, private readonly _openModalService: OpenModalService) {}

  ngOnInit() {
    if (!this.id) {
      this.id = 'default';
    }
  }

  afficheInfoBulle() {
    if (this.titre) {
      this._gtm.pushEvent({
        event: GTM_PUSH_CATEGORY_INTERRACTIONS_PAGES,
        category: GTM_PUSH_CATEGORY,
        label: this.titre,
        action: 'click - infobulles',
        value: 0,
        nonInteraction: false
      });
    }

    this._openModalService.openModal(TooltipMobileComponent, { id: this.id, titre: this.titre, texte: this.texte });
  }
}
